module.exports = __webpack_public_path__ + "static/img/nav5.71ea0944.png";